<template>
    <v-container class="py-7">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Adesão ao Plano</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Adesão ao Plano',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group" style="padding-right: 16px;">

                        <!-- modal / componente para envio de e-mails de rejeição através de planilha -->
                        <!-- <v-col class="mt-n3">
                            <rejection-email-sender /> 
                        </v-col> -->

                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnNew" type="button" color="primary" elevation="0"
                                    to="/adesao-plano/graficos" v-on="on" v-bind="attrs">
                                    Gráficos por Classe
                                </v-btn>
                            </template>
                            <span>Visualizar gráficos detalhados por classe</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <template #activator="{ on, attrs }">
                                <v-btn id="btnNew" type="button" color="primary" elevation="0"
                                    @click="openModalAssignMultiple" v-on="on" v-bind="attrs">
                                    Atribuir responsável
                                </v-btn>
                            </template>
                            <span>Atribuir multiplas adesões para um responsável</span>
                        </v-tooltip>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row class="mb-n1">
            <v-col cols="12" class="d-flex align-center">
                <span class="text-h6">Métricas de Adesão</span>

            </v-col>
        </v-row>

        <v-row dense>

            <v-col cols="12" md="6">
                <v-select dense outlined label="Tipo de usuário" :items="charts.processTypeOptions" value
                    v-model="charts.metricsFilters.process_type" />
            </v-col>

            <v-col cols="12" md="3">
                <v-select dense outlined label="Seleção de métrica" :items="charts.eventTypeOptions"
                    v-model="charts.metricsFilters.metric_id" item-text="text" item-value="value" />
            </v-col>

            <v-col cols="12" md="3">
                <v-select dense outlined clearable label="Classe do credor"
                    :items="[{ text: 'Todos', value: null }, ...dataset.classOptions]"
                    v-model="charts.planOptionFilters.creditor_type" item-text="text" item-value="value" />
            </v-col>
        </v-row>

        <v-row dense>

            <v-col cols="12" md="3">
                <v-card>
                    <v-card-title class="text-subtitle-2">
                        Geral - por usuário
                    </v-card-title>
                    <v-card-text>
                        <apexchart type="bar" height="220" :options="charts.chartsData.funnel.options"
                            :series="charts.chartsData.funnel.series" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card>
                    <v-card-title class="text-subtitle-2">
                        Usuário
                    </v-card-title>
                    <v-card-text>
                        <apexchart type="bar" height="220" :options="charts.chartsData.comparison.options"
                            :series="charts.chartsData.comparison.series" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card>
                    <v-card-title class="text-subtitle-2">
                        Métricas
                    </v-card-title>
                    <v-card-text>
                        <apexchart type="donut" height="220" :options="charts.chartsData.metric.options"
                            :series="charts.chartsData.metric.series" />
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="3">
                <v-card>
                    <v-card-title class="text-subtitle-2 d-flex justify-space-between align-center">
                        <span>Interesse troca opção</span>
                        <v-chip x-small color="blue-grey lighten-4" class="blue-grey--text text--darken-2">
                            {{ selectedCreditorClassLabel }}
                        </v-chip>
                    </v-card-title>
                    <v-card-text>
                        <apexchart type="bar" height="220" :options="charts.chartsData.planChange.options"
                            :series="charts.chartsData.planChange.series" />
                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="filter-card-title">Filtros</v-card-title>
                    <v-form @submit.prevent="load()">
                        <v-divider class="mt-2"></v-divider>

                        <v-container>
                            <v-row class="mt-3">
                                <v-col cols="3" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="Nome"
                                        v-model="dataList.filter.name" hide-details outlined
                                        @click:clear="clearNameSearch">
                                    </v-text-field>
                                </v-col>
    
                                <v-col cols="3" align-self="baseline">
                                    <v-text-field style="padding-left: 8px;" dense label="CPF/CNPJ"
                                        v-model="dataList.filter.registration" hide-details outlined>
                                    </v-text-field>
                                </v-col>

                                <v-col cols="3">
                                    <v-text-field dense outlined hide-details label="Data" type="date"
                                        v-model="dataList.filter.date" />
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-autocomplete dense
                                        :items="[{ id: null, name: 'Todos' }, { id: -1, name: 'Sem responsável' }, ...dataList.admins]"
                                        label="Responsável" v-model="dataList.filter.responsible_admin_id"
                                        item-value="id" item-text="name" outlined hide-details="auto"
                                        no-data-text="Nenhum responsável encontrado" clear>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="3">
                                    <v-select dense outlined hide-details clearable label="Situação da revisão"
                                        :items="dataset.reviewStatusOptions" item-text="text" item-value="value"
                                        v-model="dataList.filter.reviewed_status">
                                    </v-select>
                                </v-col>

                                <v-col v-if="Number(dataList.filter.status) === 5" cols="12" sm="3">
                                    <v-select dense outlined hide-details clearable label="Nível do alerta"
                                        :items="dataset.alertTypeOptions" item-text="text" item-value="value"
                                        v-model="dataList.filter.alert_type">
                                    </v-select>
                                </v-col>

                                <v-spacer></v-spacer>

                                <v-col v-if="hasFilters()" cols="auto" style="padding-right: 1px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-btn v-on="on" id="btnClearFilter" type="button" outlined color="primary"
                                                @click="clearFilters">
                                                Limpar</v-btn>
                                        </template>
                                        <span>Limpar filtros de busca selecionados</span>
                                    </v-tooltip>
                                </v-col>

                                <v-col cols="auto" style="padding-right: 16px;">
                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-btn id="btnFilter" type="submit" color="primary" dark elevation="2"
                                                v-on="on" v-bind="attrs">
                                                Filtrar
                                            </v-btn>
                                        </template>
                                        <span>Filtrar dados</span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>
                                    <template>
                                        <v-tabs v-model="activeTab">
                                            <v-tab @click="setFilterStatus('')">Todos</v-tab>
                                            <v-tab @click="setFilterStatus(0)">Pendente</v-tab>
                                            <v-tab @click="setFilterStatus(1)">Aprovado</v-tab>
                                            <v-tab @click="setFilterStatus(2)">Rejeitado</v-tab>
                                            <v-tab @click="setFilterStatus(3)">Empresa</v-tab>
                                            <v-tab @click="setFilterStatus(4)">Pessoa Fisica</v-tab>
                                            <v-tab @click="setFilterStatus(5)">Alerta</v-tab>
                                            <!-- <v-tab @click="setFilterStatus(5)">Data</v-tab> -->
                                        </v-tabs>
                                    </template>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>

                    <v-card-title class="table-card-title d-flex align-center">
                        <span>Adesão ao Plano</span>
                        <v-spacer></v-spacer>
                        <v-menu offset-y :close-on-content-click="false">
                            <template #activator="{ on, attrs }">
                                <v-btn small outlined color="primary" v-bind="attrs" v-on="on">
                                    <v-icon small left>mdi-view-column-outline</v-icon>
                                    Colunas
                                </v-btn>
                            </template>
                            <v-card min-width="280">
                                <v-card-title class="text-subtitle-2 py-2">
                                    Exibir colunas
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-text class="py-2">
                                    <v-checkbox v-for="header in hideableHeaders" :key="header.value"
                                        :input-value="isColumnVisible(header.value)" :label="header.text" dense
                                        hide-details class="mt-1" @change="toggleColumn(header.value, $event)" />
                                </v-card-text>
                            </v-card>
                        </v-menu>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table :headers="visibleTableHeaders" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhuma adesão ao plano foi encontrada" loading-text="Carregando dados..."
                            class="app-table hover-table plan-adherence-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.name_audit_alert`]="{ item }">
                                <v-menu v-if="hasNameAuditAlert(item)" offset-y max-width="420">
                                    <template #activator="{ on, attrs }">
                                        <v-btn icon small v-bind="attrs" v-on="on">
                                            <v-icon :color="getNameAuditColor(item)">
                                                {{ getNameAuditIcon(item) }}
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title class="text-subtitle-2 py-2">
                                            Divergência de nome
                                        </v-card-title>
                                        <v-divider></v-divider>
                                        <v-card-text class="text-body-2 pt-3">
                                            <v-chip x-small label class="mb-3" :color="getNameAuditColor(item)"
                                                text-color="white">
                                                {{ getNameAuditLevelLabel(item) }}
                                            </v-chip>
                                            <div v-for="(message, index) in getNameAuditMessages(item)" :key="index"
                                                class="mb-2">
                                                {{ message }}
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                                <span v-else class="grey--text text--lighten-1">-</span>
                            </template>

                            <template v-slot:[`item.user.name`]="{ item }">
                                <div class="d-flex align-items-center">
                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="item.interest_plan_option != null" v-on="on"
                                                color="blue darken-1" class="ml-1" small>
                                                mdi-swap-horizontal-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>
                                            Credor manifestou interesse em trocar a opção de pagamento
                                        </span>
                                    </v-tooltip>

                                    <span>{{ item.user.name.toUpperCase() }}</span>

                                </div>
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip small class="text-uppercase font-weight-bold text-caption"
                                    :color="getStatusColor(item.status)" label text-color="white">
                                    {{ getStatusLabel(item.status) }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.responsible`]="{ item }">
                                {{ item.responsible ? item.responsible.name : 'N/A' }}
                            </template>

                            <template v-slot:[`item.user.registration`]="{ item }">
                                {{ formatCpfCnpj(item.user.registration) }}
                            </template>

                            <template v-slot:[`item.signer_registration`]="{ item }">
                                {{ formatCpfCnpj(item.signer_registration) }}
                            </template>

                            <template v-slot:[`item.generated_creditor_registration`]="{ item }">
                                {{ formatCpfCnpj(item.generated_creditor_registration) }}
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                {{ getCreditorTypeName(item.type) }}
                            </template>

                            <template v-slot:[`item.plan_option`]="{ item }">
                                {{ getPlanOptionLabel(item.plan_option, item.type) }}
                            </template>

                            <template v-slot:[`item.interest_plan_option`]="{ item }">
                                {{ getPlanOptionLabel(item.interest_plan_option, item.type) }}
                            </template>

                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ formatDateTime(item.created_at) }}
                            </template>

                            <template v-slot:[`item.updated_at`]="{ item }">
                                {{ formatDateTime(item.updated_at) }}
                            </template>

                            <template v-slot:[`item.uploaded_at`]="{ item }">
                                {{ formatDateTime(item.uploaded_at) }}
                            </template>

                            <template v-slot:[`item.reviewed_by`]="{ item }">
                                {{ getAdminName(item.reviewed_by) }}
                            </template>

                            <template v-slot:[`item.reviewed_at`]="{ item }">
                                {{ formatReviewed(item.reviewed_at, "DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.cert_valid_from`]="{ item }">
                                {{ formatDateTime(item.cert_valid_from) }}
                            </template>

                            <template v-slot:[`item.cert_valid_to`]="{ item }">
                                {{ formatDateTime(item.cert_valid_to) }}
                            </template>

                            <template v-slot:[`item.name_audit_checked_at`]="{ item }">
                                {{ formatDateTime(item.name_audit_checked_at) }}
                            </template>

                            <template v-slot:[`item.generated_doc`]="{ item }">
                                {{ formatDocumentId(item.generated_doc) }}
                            </template>

                            <template v-slot:[`item.uploaded_doc`]="{ item }">
                                {{ formatDocumentId(item.uploaded_doc) }}
                            </template>

                            <template v-slot:[`item.generated_doc_url`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                            :disabled="!item.generated_doc_url" @click="openPdf(item.generated_doc_url)">
                                            <v-icon>mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>PDF da adesão</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.uploaded_doc_url`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                            :disabled="!item.uploaded_doc_url" @click="openPdf(item.uploaded_doc_url)">
                                            <v-icon>mdi-file-check-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>PDF assinado</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.review_action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn icon small :color="item.reviewed_at ? 'success' : 'grey darken-1'"
                                            v-bind="attrs" v-on="on" @click="toggleReview(item)">
                                            <v-icon>{{ item.reviewed_at ? 'mdi-check-decagram' : 'mdi-check-circle-outline' }}</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ item.reviewed_at ? 'Desmarcar revisão' : 'Marcar como revisado' }}</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.reject_action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn icon small color="error" v-bind="attrs" v-on="on"
                                            :disabled="Number(item.status) === 2" @click="openRejectDialog(item)">
                                            <v-icon>mdi-close-octagon-outline</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Rejeitar adesão</span>
                                </v-tooltip>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs"
                                                :disabled="!$check(user, ['planadherence.find'])"
                                                @click="viewItem(item)" size="large" class="me-2">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on, attrs }">
                                            <v-icon v-on="on" v-bind="attrs"
                                                :disabled="!$check(user, ['planadherence.delete'])"
                                                @click="deleteItem(item)" size="large" class="me-2">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Excluir</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-on="on"
                                                :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                                @click="redirectItem(item)" size="large" class="me-2">
                                                mdi-share-outline
                                            </v-icon>
                                        </template>
                                        <span>Direcionar para outro responsável</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="deleteDialog" max-width="500px">
            <v-card>
                <v-card-title class="headline">
                    Excluir Adesão ao Plano
                </v-card-title>

                <v-card-text>
                    Tem certeza que deseja continuar?<br><br>
                    <strong>OBS.: </strong>
                    <span style="color: red;">Esta operação é irreversível!</span>

                    <v-textarea v-model="deleteReason" label="Motivo da exclusão" outlined rows="3" auto-grow
                        class="mt-4" required></v-textarea>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="deleteDialog = false">
                        Cancelar
                    </v-btn>

                    <v-btn color="red darken-1" text @click="confirmDelete">
                        Excluir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rejectDialog" max-width="500px">
            <v-card>
                <v-card-title class="headline">
                    Rejeitar Adesão ao Plano
                </v-card-title>

                <v-card-text>
                    Confirma a rejeição da adesão
                    <strong v-if="itemToReject">#{{ itemToReject.id }}</strong>?
                    <br><br>
                    Esta ação altera o status da adesão para rejeitado.
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text @click="closeRejectDialog">
                        Cancelar
                    </v-btn>

                    <v-btn color="red darken-1" text :loading="rejectLoading" @click="confirmReject">
                        Rejeitar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="modalAdminRedirect" max-width="600px">
            <v-card>
                <v-card-title class="text-center text--darken-2"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Atribuir Responsável
                </v-card-title>
                <br>
                <v-card-text>
                    <p>
                        Selecione o responsável para o qual deseja atribuir esta Adesão.
                    </p>

                    <p>Adesão número: <strong>{{ redirectAdminId }}</strong></p>
                    <br>
                    <v-form ref="contraditoryForm" @submit.prevent="saveResponsibleAdmin">
                        <v-row>
                            <v-col cols="12" sm="12">

                                <v-autocomplete v-model="dataset.redirect.responsible_admin_id" :items="dataList.admins"
                                    item-text="name" item-value="id" label="Selecionar responsável" outlined
                                    hide-details="auto" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-spacer></v-spacer>
                            <v-btn text color="grey" @click="closeModalAdminRedirect()">Cancelar</v-btn>
                            <v-btn :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                color="primary" type="submit" :loading="loadingAdminRedirect">Salvar</v-btn>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- Modal de atribuir múltiplas adesões para um responsável -->
        <v-dialog v-model="modalAssignMultiple" max-width="600px">

            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Atribuir Responsável
                </v-card-title>
                <br>
                <v-card-text>

                    <p class="mb-2">
                        Preencha os dados abaixo para atribuir adesões para um responsável.
                    </p>
                    <br>
                    <v-form ref="assignMultipleForm" @submit.prevent="saveAssignMultiple">
                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="qtRequest" type="number" label="Total pedidos"
                                    v-model="dataset.assignMultiple.req_quantity" outlined hide-details="auto" :rules="[value => value === null || value === '' || (Number.isInteger(Number(value)) && Number(value) > 0) ||
                                        'Somente números positivos são permitidos'
                                    ]">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-autocomplete v-model="dataset.assignMultiple.status"
                                    :items="dataset.planAdherenceStatus" item-text="name" item-value="id" label="Status"
                                    outlined hide-details="auto" no-data-text="Nenhum status encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row class="mb-n5">
                            <v-col cols="6">
                                <v-select dense outlined clearable hide-details label="Classe"
                                    :items="dataset.classOptions" item-text="text" item-value="value"
                                    v-model="dataset.assignMultiple.creditor_type"
                                    @change="dataset.assignMultiple.plan_option = null" />
                            </v-col>

                            <v-col cols="6">
                                <v-select dense outlined clearable hide-details label="Opção de pagamento"
                                    :items="paymentOptions" item-text="text" item-value="value"
                                    v-model="dataset.assignMultiple.plan_option"
                                    :disabled="!dataset.assignMultiple.creditor_type" />
                            </v-col>
                        </v-row>

                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-select dense outlined clearable hide-details label="Nível do alerta"
                                    :items="dataset.alertTypeOptions" item-text="text" item-value="value"
                                    v-model="dataset.assignMultiple.alert_type" />
                            </v-col>
                        </v-row>

                        <v-row class="mb-n5">
                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountPlus" type="number" label="Valor igual ou maior"
                                    v-model="dataset.assignMultiple.amount_plus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-currency-field dense id="qtAmountMinus" type="number" label="Valor igual ou menor"
                                    v-model="dataset.assignMultiple.amount_minus" outlined hide-details="auto"
                                    :allowNegative=false>
                                </v-currency-field>
                            </v-col>

                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.assignMultiple.responsible_id" :items="dataList.admins"
                                    item-text="name" item-value="id" label="Selecionar responsável" outlined
                                    hide-details="auto" required :rules="[$rules.required]"
                                    no-data-text="Nenhum responsável encontrado" dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12">
                                <v-checkbox v-model="dataset.assignMultiple.without_responsible" dense>
                                    <template #label>
                                        <span class="d-inline-flex align-center">
                                            Somente sem responsável
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                                                        mdi-help-circle
                                                    </v-icon>
                                                </template>
                                                <span>
                                                    Ao marcar esta opção, o responsável selecionado será atribuído às
                                                    Adesões ao Plano <br />
                                                    que se enquadrem nas regras selecionadas, e que ainda não possuem um
                                                    responsável designado.
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>

                        <br>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn text color="grey" @click="closeModalAssignMultiple">Cancelar</v-btn>
                                <v-btn color="primary" type="submit"
                                    :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                    :loading="loadingResponsibleAssign">Atribuir</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- <v-dialog v-model="modalAssignMultiple" max-width="600px">

            <v-card>
                <v-card-title class="card-title"
                    style="border-bottom: 4px solid #007bff; padding-bottom: 8px; display: flex; justify-content: center; align-items: center;">
                    Atribuir Responsável
                </v-card-title>
                <br>
                <v-card-text>

                    <p class="mb-2">
                        Preencha os dados abaixo para atribuir adesões para um responsável.
                    </p>
                    <br>
                    <v-form ref="assignMultipleForm" @submit.prevent="saveAssignMultiple">

                        <v-row>
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="star_id" type="number" label="ID Inicial"
                                    v-model="dataset.assignMultiple.start_id"
                                    :rules="[value => !value || /^\d+$/.test(value) || 'Somente números positivos são permitidos']"
                                    outlined>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense id="end_id" type="number" label="ID Final"
                                    v-model="dataset.assignMultiple.end_id"
                                    :rules="[value => !value || /^\d+$/.test(value) || 'Somente números positivos são permitidos']"
                                    outlined>
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-n5">
                            <v-col cols="12" sm="6">
                                <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="formatDateBR(dataset.assignMultiple.start_date)"
                                            label="Data inicial" outlined dense readonly 
                                            prepend-inner-icon="mdi-calendar-start" v-bind="attrs" v-on="on" />
                                    </template>

                                    <v-date-picker v-model="dataset.assignMultiple.start_date" locale="pt-br"
                                        @input="startDateMenu = false" :max="new Date().toISOString().substr(0, 10)"/>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="6">
                                <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field :value="formatDateBR(dataset.assignMultiple.end_date)"
                                            label="Data final" outlined dense readonly
                                            prepend-inner-icon="mdi-calendar-end" v-bind="attrs" v-on="on" />
                                    </template>

                                    <v-date-picker v-model="dataset.assignMultiple.end_date" locale="pt-br"
                                        @input="endDateMenu = false" :max="new Date().toISOString().substr(0, 10)"/>
                                </v-menu>
                            </v-col>
                        </v-row>
                        
                        <v-row class="mt-n5">
                           

                            <v-col cols="12" sm="12">
                                <v-autocomplete v-model="dataset.assignMultiple.responsible_id"
                                    :items="dataList.admins" item-text="name" item-value="id"
                                    label="Selecionar responsável" outlined hide-details="auto" required
                                    :rules="[$rules.required]" no-data-text="Nenhum responsável encontrado"
                                    dense></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row >
                            <v-col cols="12" sm="12">
                                <v-checkbox v-model="dataset.assignMultiple.without_responsible" dense>
                                    <template #label>
                                        <span class="d-inline-flex align-center">
                                            Somente sem responsável
                                            <v-tooltip bottom>
                                                <template #activator="{ on, attrs }">
                                                    <v-icon small color="primary" class="ml-2" v-bind="attrs" v-on="on">
                                                        mdi-help-circle
                                                    </v-icon>
                                                </template>
                                                <span>
                                                    Ao marcar esta opção, o responsável selecionado será atribuído às
                                                    Adesões ao Plano que se enquadrarem nas regras selecionadas e 
                                                    que ainda não possuem um responsável designado.
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>

                        <br>
                        <v-row justify="end">
                            <v-col cols="auto">
                                <v-btn text color="grey" @click="closeModalAssignMultiple">Cancelar</v-btn>
                                <v-btn color="primary" type="submit"
                                    :disabled="!$check(user, ['objectionevents.update.responsible.redirect'])"
                                    :loading="loadingResponsibleAssign">Atribuir</v-btn>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog> -->

    </v-container>

</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';

import planAdherenceStatus from '@/common/data/plan-adherence-status.data'

//import RejectionEmailSender from '@/components/PlanAdherenceEmailRejectionSender.vue'

import eventTypeOptions from '@/common/data/action-event-types.data';

import VueApexCharts from 'vue-apexcharts'

import { cpf, cnpj } from 'cpf-cnpj-validator'

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "HelpList",
    components: {
        apexchart: VueApexCharts,
        //RejectionEmailSender: RejectionEmailSender,
    },

    data: () => ({
        user: null,
        modalAssignMultiple: false,
        startDateMenu: false,
        endDateMenu: false,
        activeTab: 0,
        dataset: {
            data: {},
            planAdherenceStatus: planAdherenceStatus,
            classOptions: [
                { text: 'Classe I - Trabalhista', value: 1 },
                { text: 'Classe III - Quirografário', value: 3 },
                { text: 'Classe IV - ME/EPP', value: 4 },
            ],
            planOptionText: {
                1: [
                    { text: 'OPÇÃO A', value: 1 },
                ],
                3: [
                    { text: 'OPÇÃO A', value: 1 },
                    { text: 'OPÇÃO B', value: 2 },
                    { text: 'OPÇÃO C', value: 3 },
                    { text: 'OPÇÃO D', value: 4 },
                    { text: 'OPÇÃO E', value: 5 },
                ],
                4: [
                    { text: 'OPÇÃO A', value: 1 },
                    { text: 'OPÇÃO B', value: 2 },
                ],
            },
            alertTypeOptions: [
                { text: 'Todos os níveis', value: null },
                { text: 'Baixo', value: 'low' },
                { text: 'Médio', value: 'medium' },
                { text: 'Crítico', value: 'critical' },
            ],
            reviewStatusOptions: [
                { text: 'Revisadas', value: 'reviewed' },
                { text: 'Não revisadas', value: 'not_reviewed' },
            ],
            redirect: {
                responsible_admin_id: null,
                is_complex: null
            },
            assignMultiple: {
                responsible_id: null,
                req_quantity: null,
                creditor_type: null,
                amount_plus: null,
                amount_minus: null,
                plan_option: null,
                status: null,
                alert_type: null,
                without_responsible: false,

            },
        },
        charts: {
            metricsFilters: {
                process_type: 1,
                metric_id: 4,
            },
            planOptionFilters: {
                option_id: null,
                creditor_type: null,
            },
            processTypeOptions: [
                { text: 'Credor', value: 1 },
                { text: 'Procurador', value: 2 },
            ],
            eventTypeOptions: eventTypeOptions,
            chartsData: {
                funnel: {
                    series: [],
                    options: {},
                },
                comparison: {
                    series: [],
                    options: {},
                },
                metric: {
                    series: [],
                    options: {},
                },
                planChange: {
                    series: [],
                    options: {},
                },
            },
        },
        deleteDialog: false,
        deleteReason: "",
        itemToDelete: null,
        rejectDialog: false,
        rejectLoading: false,
        itemToReject: null,
        hiddenTableColumns: [],
        modalAdminRedirect: false,
        modalAdminChange: false,
        loadingAdminRedirect: false,
        redirectAdminId: null,
        loadingContraditory: false,
        loadingResponsibleAssign: false,
        dataList: {
            filter: {
                name: "",
                registration: "",
                status: "",
                date: "",
                alert_type: null,
                responsible_admin_id: null,
                reviewed_status: null,
            },
            headers: [
                { text: "ID", value: "id", width: 80 },
                { text: "Alerta", value: "name_audit_alert", sortable: false, width: 90 },
                { text: "Nome cadastro", value: "user.name", width: 260 },
                { text: "CPF/CNPJ cadastro", value: "user.registration", width: 170 },
                { text: "Email cadastro", value: "user.email", width: 240 },
                { text: "Telefone cadastro", value: "user.phone_number", width: 160 },
                { text: "Classe", value: "type", width: 190 },
                { text: "Opção", value: "plan_option", width: 110 },
                { text: "Interesse troca", value: "interest_plan_option", width: 140 },
                { text: "Status", value: "status", width: 130 },
                { text: "Responsável", value: "responsible", width: 220 },
                { text: "Revisado por", value: "reviewed_by", width: 180 },
                { text: "Revisado em", value: "reviewed_at", width: 170 },
                { text: "Nome PDF", value: "generated_creditor_name", width: 260 },
                { text: "CPF/CNPJ PDF", value: "generated_creditor_registration", width: 170 },
                { text: "Nome termo", value: "generated_term_creditor_name", width: 260 },
                { text: "Nome GOV", value: "signer_name", width: 260 },
                { text: "CPF/CNPJ GOV", value: "signer_registration", width: 170 },
                { text: "Email GOV", value: "signer_email", width: 240 },
                { text: "Perfil validado", value: "validated_by_role", width: 190 },
                { text: "Certificado início", value: "cert_valid_from", width: 170 },
                { text: "Certificado fim", value: "cert_valid_to", width: 170 },
                { text: "Enviado em", value: "uploaded_at", width: 170 },
                { text: "Auditado em", value: "name_audit_checked_at", width: 170 },
                { text: "Documento gerado", value: "generated_doc", width: 180 },
                { text: "Documento assinado", value: "uploaded_doc", width: 190 },
                { text: "Criado em", value: "created_at", width: 170 },
                { text: "Atualizado em", value: "updated_at", width: 170 },
                { text: "PDF da adesão", value: "generated_doc_url", sortable: false, width: 110 },
                { text: "PDF assinado", value: "uploaded_doc_url", sortable: false, width: 110 },
                { text: "Revisar", value: "review_action", sortable: false, width: 90 },
                { text: "Rejeitar", value: "reject_action", sortable: false, width: 90 },
                { text: 'Ações', value: 'actions', sortable: false, alwaysVisible: true, width: 160 },
            ],
            data: [],
            admins: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 10,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            }
        },
    }),

    created() {

        this.restoreTableColumnsFromStorage();
        this.restoreFiltersFromStorage();

        if (this.$route.query.page) {
            this.dataList.options.page = Number(this.$route.query.page);
        }

        this.load();
        this.loadAdmins();
        this.loadChartsMetrics();
    },

    computed: {

        paymentOptions() {
            if (!this.dataset.assignMultiple.creditor_type) {
                return []
            }

            return this.dataset.planOptionText[this.dataset.assignMultiple.creditor_type] || []
        },

        selectedCreditorClassLabel() {
            const type = this.charts.planOptionFilters.creditor_type;

            if (!type) return 'Todos';

            const found = this.dataset.classOptions.find(o => o.value === type);
            return found ? found.text.split(' - ')[1] || found.text : 'Todos';
        },

        hideableHeaders() {
            return this.dataList.headers.filter(header => !header.alwaysVisible);
        },

        visibleTableHeaders() {
            return this.dataList.headers.filter(header => header.alwaysVisible || !this.hiddenTableColumns.includes(header.value));
        },

    },

    watch: {
        'charts.metricsFilters.process_type'(newVal) {
            this.saveFiltersToStorage();
            this.loadChartsMetrics()
        },

        'charts.metricsFilters.metric_id'(newVal) {
            this.saveFiltersToStorage();
            this.loadChartsMetrics()
        },

        'charts.planOptionFilters.creditor_type'(newVal) {
            this.saveFiltersToStorage();
            this.loadChartsMetrics();
        },

    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.saveFiltersToStorage();
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.saveFiltersToStorage();
            this.load(true);
        },

        isColumnVisible(value) {
            return !this.hiddenTableColumns.includes(value);
        },

        toggleColumn(value, visible) {
            if (visible) {
                this.hiddenTableColumns = this.hiddenTableColumns.filter(column => column !== value);
            } else if (!this.hiddenTableColumns.includes(value)) {
                this.hiddenTableColumns.push(value);
            }

            this.saveTableColumnsToStorage();
        },

        saveTableColumnsToStorage() {
            localStorage.setItem('planAdherenceHiddenColumns', JSON.stringify(this.hiddenTableColumns));
        },

        restoreTableColumnsFromStorage() {
            const saved = localStorage.getItem('planAdherenceHiddenColumns');
            if (!saved) return;

            try {
                const hiddenColumns = JSON.parse(saved);
                this.hiddenTableColumns = Array.isArray(hiddenColumns) ? hiddenColumns : [];
            } catch (error) {
                this.hiddenTableColumns = [];
            }
        },

        async setFilterStatus(value) {
            this.dataList.filter.status = value;
            if (Number(value) !== 5) {
                this.dataList.filter.alert_type = null;
            }
            this.dataList.options.page = 1;
            this.saveFiltersToStorage();
            await this.load();
        },

        hasFilters() {
            return Object.values(this.dataList.filter).some(value => value !== "" && value !== null && value !== undefined);
        },

        async clearFilters() {
            this.dataList.filter.name = "";
            this.dataList.filter.registration = "";
            this.dataList.filter.status = "";
            this.dataList.filter.date = "";
            this.dataList.filter.alert_type = null;
            this.dataList.filter.responsible_admin_id = null;
            this.dataList.filter.reviewed_status = null;
            this.activeTab = 0;
            localStorage.removeItem('planAdherenceFilters');
            await this.load();
        },

        clearNameSearch() {
            this.dataList.filter.name = "";
            this.activeTab = 0;
            this.setFilterStatus('');
            this.load();
        },

        async loadAdmins() {
            try {
                const result = await axios.get(`/api/admin/list`, { params: { start: 1, limit: 100000, search: {} } });

                const data = result.data.content.data;

                data.sort((a, b) => a.name.localeCompare(b.name));

                this.dataList.admins = data;
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            }
        },

        formatReviewed(value, fmt = "DD/MM/YYYY HH:mm:ss") {
            if (!value) return "N/A";
            if (String(value).startsWith('0000-00-00')) return "N/A";
            return moment(String(value)).isValid() ? moment(String(value)).format(fmt) : "N/A";
        },

        formatDateTime(value, fmt = "DD/MM/YYYY HH:mm:ss") {
            if (!value) return "N/A";
            if (String(value).startsWith('0000-00-00')) return "N/A";
            return moment(String(value)).isValid() ? moment(String(value)).format(fmt) : "N/A";
        },

        formatDocumentId(value, size = 8) {
            if (!value) return 'N/A';
            const text = String(value);
            return text.length > size ? `${text.slice(0, size)}...` : text;
        },

        getCreditorTypeName(typeId) {
            const type = this.dataset.classOptions.find(item => Number(item.value) === Number(typeId));
            return type ? type.text : 'N/A';
        },

        hasNameAuditAlert(item) {
            if (!item) return false;
            if (this.getActionableNameAuditIssues(item).length) return true;
            return !!(item.alert && item.name_audit_status !== 'mismatch');
        },

        getNameAuditLevel(item) {
            if (!this.hasNameAuditAlert(item)) return null;

            const issues = this.getActionableNameAuditIssues(item);

            if (issues.some(issue => this.getNameAuditIssueSeverity(issue) === 'critical')) {
                return 'critical';
            }

            if (issues.some(issue => this.getNameAuditIssueSeverity(issue) === 'medium')) {
                return 'medium';
            }

            return 'low';
        },

        getNameAuditColor(item) {
            const level = this.getNameAuditLevel(item);

            if (level === 'critical') return 'red darken-2';
            if (level === 'medium') return 'amber darken-2';
            return 'green darken-1';
        },

        getNameAuditIcon(item) {
            const level = this.getNameAuditLevel(item);

            if (level === 'critical') return 'mdi-alert-octagon';
            if (level === 'medium') return 'mdi-alert';
            return 'mdi-alert-circle-outline';
        },

        getNameAuditLevelLabel(item) {
            const level = this.getNameAuditLevel(item);

            if (level === 'critical') return 'Crítico';
            if (level === 'medium') return 'Médio';
            return 'Baixo';
        },

        getNameAuditMessages(item) {
            const issues = this.getActionableNameAuditIssues(item);

            if (issues.length) {
                return issues.map(issue => this.formatNameAuditIssue(issue));
            }

            if (item.alert) return [item.alert];

            return ['Divergência de nome identificada.'];
        },

        formatNameAuditIssue(issue) {
            if (!issue || !issue.type) return 'Divergência de nome identificada.';

            if (issue.type === 'creditor_name_changed_after_generation') {
                return `${this.getNameAuditClassificationLabel(issue)}: PDF "${issue.generated_name || 'N/A'}" <> cadastro atual "${issue.current_name || 'N/A'}"`;
            }

            if (issue.type === 'signer_name_differs_from_generation_snapshot') {
                return `${this.getNameAuditClassificationLabel(issue)}: assinatura "${issue.signer_name || 'N/A'}" <> ${issue.role || 'assinante esperado'} "${issue.generated_name || 'N/A'}"`;
            }

            if (issue.left_value || issue.right_value) {
                return `${this.getNameAuditClassificationLabel(issue)}: ${issue.left_label || 'Origem 1'} "${issue.left_value || 'N/A'}" <> ${issue.right_label || 'Origem 2'} "${issue.right_value || 'N/A'}"`;
            }

            if (issue.type === 'signature_provider_not_gov_br') {
                return `Assinatura realizada com certificado diferente de GOV.BR: ${issue.provider || 'N/A'}${issue.signer_name ? ` - ${issue.signer_name}` : ''}`;
            }

            if (issue.type === 'generated_signers_snapshot_parse_error') {
                return 'Não foi possível ler os dados de assinantes gerados no PDF.';
            }

            return issue.type;
        },

        getActionableNameAuditIssues(item) {
            const details = item && item.name_audit_details_parsed ? item.name_audit_details_parsed : {};
            const issues = Array.isArray(details.issues) ? details.issues : [];
            return issues.filter(issue => this.getNameAuditIssueSeverity(issue));
        },

        normalizeNameForAudit(value) {
            return String(value || '')
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase()
                .replace(/[^A-Z0-9\s]/g, ' ')
                .replace(/\s+/g, ' ')
                .trim();
        },

        getNameTokensForAudit(value) {
            const connectors = ['DA', 'DE', 'DO', 'DAS', 'DOS', 'E', 'DEL', 'DELLA', 'DI', 'DU'];
            return this.normalizeNameForAudit(value)
                .split(' ')
                .filter(token => token && !connectors.includes(token));
        },

        getLevenshteinDistance(left, right) {
            if (left === right) return 0;
            if (!left) return right.length;
            if (!right) return left.length;

            let previous = Array.from({ length: right.length + 1 }, (_, index) => index);

            for (let i = 1; i <= left.length; i += 1) {
                const current = [i];

                for (let j = 1; j <= right.length; j += 1) {
                    current[j] = Math.min(
                        previous[j] + 1,
                        current[j - 1] + 1,
                        previous[j - 1] + (left[i - 1] === right[j - 1] ? 0 : 1)
                    );
                }

                previous = current;
            }

            return previous[right.length];
        },

        classifyNameAuditDifference(left, right) {
            const normalizedLeft = this.normalizeNameForAudit(left);
            const normalizedRight = this.normalizeNameForAudit(right);

            if (!normalizedLeft || !normalizedRight) return 'missing_or_unreadable_name';
            if (normalizedLeft === normalizedRight && String(left || '') !== String(right || '')) return 'accent_or_punctuation_only';
            if (normalizedLeft === normalizedRight) return 'same_after_normalization';

            const leftTokens = this.getNameTokensForAudit(left);
            const rightTokens = this.getNameTokensForAudit(right);
            const rightTokenSet = new Set(rightTokens);
            let common = 0;
            let initialMatches = 0;
            let typoMatches = 0;

            for (const token of leftTokens) {
                if (rightTokenSet.has(token)) {
                    common += 1;
                    continue;
                }

                if (token.length === 1 && rightTokens.some(rightToken => rightToken.startsWith(token))) {
                    initialMatches += 1;
                    continue;
                }

                if (rightTokens.some(rightToken => rightToken.length === 1 && token.startsWith(rightToken))) {
                    initialMatches += 1;
                    continue;
                }

                if (rightTokens.some(rightToken => Math.max(token.length, rightToken.length) >= 5 && this.getLevenshteinDistance(token, rightToken) <= 1)) {
                    typoMatches += 1;
                }
            }

            const minLength = Math.min(leftTokens.length, rightTokens.length) || 1;
            const maxLength = Math.max(leftTokens.length, rightTokens.length) || 1;
            const aligned = common + initialMatches + typoMatches;

            if (common === 0 && initialMatches === 0 && typoMatches === 0) return 'completely_different_name';
            if (common === leftTokens.length && common === rightTokens.length) return 'same_after_normalization';
            if (initialMatches && aligned >= minLength && common >= 1) return 'abbreviation_or_initial';
            if (typoMatches && aligned >= minLength && common >= 1) return 'probable_typo_or_spelling_variation';
            if (common >= minLength && maxLength - minLength <= 2) return 'partial_or_missing_middle_name';
            if (common / maxLength < 0.34) return 'mostly_different_name';

            return 'substantial_name_difference';
        },

        getNameAuditIssueClassification(issue) {
            if (!issue) return null;
            if (issue.classification) return issue.classification;

            if (issue.type === 'creditor_name_changed_after_generation') {
                return this.classifyNameAuditDifference(issue.generated_name, issue.current_name);
            }

            if (issue.type === 'signer_name_differs_from_generation_snapshot') {
                return this.classifyNameAuditDifference(issue.generated_name, issue.signer_name);
            }

            if (issue.left_value || issue.right_value) {
                return this.classifyNameAuditDifference(issue.left_value, issue.right_value);
            }

            return null;
        },

        getNameAuditIssueSeverity(issue) {
            if (!issue) return null;
            if (issue.type === 'signature_provider_not_gov_br') return 'critical';
            if (issue.severity) return issue.severity;
            if (issue.type === 'generated_signers_snapshot_parse_error') return 'medium';

            const classification = this.getNameAuditIssueClassification(issue);

            if (['same_after_normalization', 'accent_or_punctuation_only'].includes(classification)) return null;

            if ([
                'partial_or_missing_middle_name',
                'abbreviation_or_initial',
                'probable_typo_or_spelling_variation',
            ].includes(classification)) {
                return 'low';
            }

            if (classification === 'substantial_name_difference') return 'medium';

            if (classification) return 'critical';

            return null;
        },

        getNameAuditClassificationLabel(issue) {
            const classification = this.getNameAuditIssueClassification(issue);

            const labels = {
                partial_or_missing_middle_name: 'Variação por sobrenome intermediário',
                abbreviation_or_initial: 'Variação por abreviação/inicial',
                probable_typo_or_spelling_variation: 'Provável typo ou variação de escrita',
                substantial_name_difference: 'Diferença substancial',
                mostly_different_name: 'Nome majoritariamente diferente',
                completely_different_name: 'Nome completamente divergente',
                missing_or_unreadable_name: 'Nome ausente ou ilegível',
            };

            return labels[classification] || 'Divergência de nome';
        },

        getAdminName(adminId) {

            if (!adminId) return "N/A";

            const admin = this.dataList.admins.find(a => a.id === adminId);

            return admin ? admin.name : "N/A";
        },

        // debounce: _.debounce(function () {
        //     this.reload();
        // }, 500),

        // reload: function () {
        //     this.load();
        // },

        async load() {
            this.user = this.$root.user.data || this.$root.user;

            const effectiveStatus = Number(this.activeTab) === 6 ? 5 : this.dataList.filter.status;
            this.dataList.filter.status = effectiveStatus;

            this.saveFiltersToStorage();

            let search = {};

            if (this.dataList.filter.name && String(this.dataList.filter.name).trim() !== "") {
                search.name = String(this.dataList.filter.name).trim();
            }

            if (this.dataList.filter.registration && String(this.dataList.filter.registration).trim() !== "") {
                search.registration = String(this.dataList.filter.registration).replaceAll(/\D/g, '').trim();
            }

            if (this.dataList.filter.date && String(this.dataList.filter.date).trim() !== "") {
                search.date = String(this.dataList.filter.date).trim();
            }

            if (effectiveStatus !== "" && effectiveStatus !== null) {
                search.status = effectiveStatus;
            }

            if (Number(effectiveStatus) === 5 && this.dataList.filter.alert_type) {
                search.alert_type = this.dataList.filter.alert_type;
            }

            if (this.dataList.filter.responsible_admin_id) {
                search.responsible_admin_id = this.dataList.filter.responsible_admin_id;
            }

            if (this.dataList.filter.reviewed_status) {
                search.reviewed_status = this.dataList.filter.reviewed_status;
            }

            this.dataList.loading = true;

            const params = {
                page: this.dataList.options.page,
                limit: this.dataList.options.itemsPerPage,
                search: JSON.stringify(search)
            }

            try {
                const result = await axios.get('/api/admin/plan-adherence', { params });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 5000
                })
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            const route = this.$router.resolve({
                path: `adesao-plano/${item.id}`,
                query: {
                    page: this.dataList.options.page
                }
            });
            window.open(route.href, '_blank');
        },

        openPdf(url) {
            if (!url) return;
            window.open(url, '_blank');
        },

        async toggleReview(item) {
            if (!item || !item.id) return;

            this.dataList.loading = true;

            try {
                await axios.post(`/api/admin/plan-adherence/review/${item.id}`);

                this.$dialog.notify.info(
                    item.reviewed_at ? "Revisão removida com sucesso!" : "Adesão marcada como revisada!",
                    { position: "top-right", timeout: 2000 }
                );

                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.dataList.loading = false;
            }
        },

        openRejectDialog(item) {
            if (!item || !item.id) return;
            this.itemToReject = item;
            this.rejectDialog = true;
        },

        closeRejectDialog() {
            this.itemToReject = null;
            this.rejectDialog = false;
        },

        async confirmReject() {
            if (!this.itemToReject || !this.itemToReject.id) return;

            this.rejectLoading = true;

            try {
                await axios.post(`/api/admin/plan-adherence/reject/${this.itemToReject.id}`);

                this.$dialog.notify.info("Adesão rejeitada com sucesso!", {
                    position: "top-right",
                    timeout: 2000
                });

                this.closeRejectDialog();
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });
            } finally {
                this.rejectLoading = false;
            }
        },

        redirectItem(item) {
            this.redirectAdminId = item.id
            this.modalAdminRedirect = true;;
        },

        closeModalAdminRedirect() {
            this.dataset.redirect.responsible_admin_id = null;
            this.dataset.redirect.is_complex = null;
            this.modalAdminRedirect = false;
        },

        async saveResponsibleAdmin() {

            if (!this.dataset.redirect.responsible_admin_id && !this.dataset.redirect.is_complex) {
                this.$dialog.notify.error(
                    "Por favor selecione um responsável ou marque o item como complexo!",
                    { position: 'top-right', timeout: 5000 }
                );

                return;
            }

            const payload = {
                responsible_admin_id: this.dataset.redirect.responsible_admin_id,
                is_complex: this.dataset.redirect.is_complex
            };

            this.loadingAdminRedirect = true;

            try {
                const response = await axios.patch(`/api/admin/plan-adherence/responsible-redirect/${this.redirectAdminId}`, payload);

                this.$dialog.notify.info("Responsável atribuído com sucesso!", { position: "top-right", timeout: 3000 });

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {

                this.loadingAdminRedirect = false;
                this.modalAdminRedirect = false;
                this.redirectAdminId = null;
                this.dataset.redirect.responsible_admin_id = null;
                this.dataset.redirect.is_complex = null;
                this.load();
            }
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            this.itemToDelete = item;
            this.deleteReason = "";
            this.deleteDialog = true;

        },

        async confirmDelete() {
            if (!this.itemToDelete) return;

            if (!this.deleteReason.trim()) {
                this.$dialog.notify.error("Informe o motivo da exclusão.", {
                    position: 'top-right',
                    timeout: 2000
                });
                return;
            }

            this.dataList.loading = true;

            try {
                await axios.delete(`/api/admin/plan-adherence/${this.itemToDelete.id}`, {
                    data: {
                        reason: this.deleteReason
                    }
                });

                this.$dialog.notify.info("Adesão ao plano excluída com sucesso!", {
                    position: "top-right",
                    timeout: 2000
                });

                this.load();

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                });

            } finally {
                this.dataList.loading = false;
                this.deleteDialog = false;
                this.itemToDelete = null;
            }
        },

        getStatusColor(status) {
            switch (status) {
                case 0:
                    return 'warning';
                case 1:
                    return 'accent';
                case 2:
                    return 'error';
                default:
                    return 'grey';
            }
        },

        getStatusLabel(status) {
            return (this.dataset.planAdherenceStatus.find(x => x.id === status) || {}).name || 'N/A';
        },

        formatCpfCnpj(value) {
            if (!value) return "N/A";

            const clean = String(value).replace(/\D/g, '');

            return clean.length == 14 ? cnpj.format(clean) : clean.length == 11 ? cpf.format(clean) : value;
        },

        openModalAssignMultiple() {
            this.modalAssignMultiple = true;
        },

        closeModalAssignMultiple() {

            this.dataset.assignMultiple.responsible_id = null;
            this.dataset.assignMultiple.req_quantity = null;
            this.dataset.assignMultiple.creditor_type = null;
            this.dataset.assignMultiple.amount_plus = null;
            this.dataset.assignMultiple.amount_minus = null;
            this.dataset.assignMultiple.plan_option = null;
            this.dataset.assignMultiple.status = null;
            this.dataset.assignMultiple.alert_type = null;
            this.dataset.assignMultiple.without_responsible = false;

            this.modalAssignMultiple = false;
        },

        async saveAssignMultiple() {

            if (!this.$refs.assignMultipleForm.validate()) {
                return;
            }

            const data = this.dataset.assignMultiple;

            if (!data.responsible_id) {
                this.$dialog.notify.error(
                    "Selecione um responsável para continuar!",
                    { position: "top-right", timeout: 4000 }
                );
                return;
            }

            if (!this.dataset.assignMultiple.req_quantity &&
                !this.dataset.assignMultiple.creditor_type &&
                !this.dataset.assignMultiple.amount_plus &&
                !this.dataset.assignMultiple.amount_minus &&
                !this.dataset.assignMultiple.plan_option &&
                !this.dataset.assignMultiple.status &&
                !this.dataset.assignMultiple.alert_type) {
                this.$dialog.notify.error(
                    "Informe ao menos um dos critérios de pesquisa!",
                    { position: "top-right", timeout: 5000 }
                );
                return;
            }

            const payload = {
                responsible_admin_id: data.responsible_id,
                without_responsible: data.without_responsible,
                req_quantity: Number(data.req_quantity) || null,
                creditor_type: data.creditor_type || null,
                amount_plus: data.amount_plus || null,
                amount_minus: data.amount_minus || null,
                plan_option: data.plan_option || null,
                status: data.status || null,
                alert_type: data.alert_type || null
            };

            this.loadingResponsibleAssign = true;

            try {
                const response = await axios.post(`/api/admin/plan-adherence/responsible-assign-multiple`, payload);

                this.closeModalAssignMultiple();

                const apiMessage = response && response.data && response.data.content && response.data.content.message
                    || "Responsável atribuído com sucesso!";

                await this.$dialog.confirm({
                    title: "Resultado",
                    text: apiMessage,
                    actions: {
                        true: {
                            text: "Ok",
                            color: "primary"
                        }
                    },
                    html: true
                });

            } catch (error) {
                this.$dialog.notify.error(
                    this.$codes(error),
                    { position: 'top-right', timeout: 2000 }
                );

            } finally {
                this.loadingResponsibleAssign = false;
                // this.closeModalAssignMultiple();
                this.load();
            }
        },

        async loadChartsMetrics() {

            const { process_type, metric_id } = this.charts.metricsFilters
            const { creditor_type } = this.charts.planOptionFilters;

            if (!process_type || !metric_id) return;

            this.charts.loading = true

            try {
                const response = await axios.get('/api/action-events', {
                    params: {
                        process_type,
                        metric_id,
                        ...(creditor_type ? { creditor_type } : {})
                    }
                })

                const data = response &&
                    response.data &&
                    response.data.content &&
                    response.data.content.data

                if (!data) return

                this.charts.chartsData.funnel = this.mapChart1(data)
                this.charts.chartsData.comparison = this.mapChart2(data)
                this.charts.chartsData.planChange = this.mapChart4(data)

                if (data.metric) {
                    this.charts.chartsData.metric = this.mapChart3(data)
                } else {
                    this.charts.chartsData.metric = {
                        series: [],
                        options: {}
                    }
                }

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 3000
                })
            } finally {
                this.charts.loading = false
            }
        },

        mapChart1(data) {

            if (!data || !data.funnel) {
                return {
                    series: [],
                    options: {}
                }
            }

            const funnelData = []

            Object.entries(data.funnel).forEach(([eventType, total]) => {
                try {
                    const label = this.getEventLabel(eventType)

                    funnelData.push({
                        x: label,
                        y: total
                    })
                } catch (err) {
                    console.error('❌ ERRO NO LOOP DO FUNNEL', {
                        eventType,
                        total,
                        err
                    })
                }
            })

            const result = {
                series: [
                    {
                        name: 'Quantidade',
                        data: funnelData
                    }
                ],
                options: {
                    chart: {
                        type: 'bar',
                        height: 220,
                        toolbar: {
                            tools: {
                                download: false
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            isFunnel: true,
                            barHeight: '80%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: val => val
                    },
                    xaxis: {
                        categories: funnelData.map(i => i.x)
                    },
                    legend: {
                        show: false
                    }
                }

            }

            return result
        },

        mapChart2(data) {
            return {
                series: [
                    {
                        name: 'Quantidade',
                        data: [
                            data.comparison.creditor,
                            data.comparison.lawyer
                        ]
                    }
                ],
                options: {
                    chart: {
                        toolbar: {
                            tools: {
                                download: false,
                            }
                        }
                    },

                    xaxis: {
                        categories: ['Credor', 'Procurador']
                    },
                    plotOptions: {
                        bar: {
                            horizontal: false
                        }
                    }
                }
            }
        },

        mapChart3(data) {

            if (!data || !data.metric) {
                return {
                    series: [],
                    options: {}
                }
            }

            const creditor = data.metric.creditor || 0
            const lawyer = data.metric.lawyer || 0
            const total = creditor + lawyer

            return {
                series: [creditor, lawyer],
                options: {
                    labels: ['Credor', 'Procurador'],

                    chart: {
                        type: 'donut'
                    },

                    legend: {
                        position: 'right'
                    },

                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                                labels: {
                                    show: true,

                                    total: {
                                        show: true,
                                        label: 'Total',
                                        formatter: () => total
                                    }
                                }
                            }
                        }
                    }
                },

                dataLabels: {
                    enabled: true
                }
            }
        },

        mapChart4(data) {

            if (!data || !data.interestOptionFunnel || !Array.isArray(data.interestOptionFunnel)) {
                return {
                    series: [],
                    options: {}
                }
            }

            const optionFilter = this.charts.planOptionFilters.option_id;

            const funnelData = data.interestOptionFunnel
                .filter(item => {
                    if (optionFilter !== null && optionFilter !== undefined) {
                        return Number(item.option) === Number(optionFilter);
                    }
                    return true;
                })
                .map(item => ({
                    x: item.label || this.getPlanOptionLabel(item.option),
                    y: item.total
                }));

            if (!funnelData.length) {
                return {
                    series: [{ name: 'Interesse em troca', data: [] }],
                    options: {
                        noData: {
                            text: 'Nenhum interesse registrado',
                            align: 'center',
                            verticalAlign: 'middle',
                        }
                    }
                }
            }

            return {
                series: [
                    {
                        name: 'Quantidade',
                        data: funnelData
                    }
                ],
                options: {
                    chart: {
                        type: 'bar',
                        height: 220,
                        toolbar: {
                            tools: {
                                download: false
                            }
                        }
                    },
                    plotOptions: {
                        bar: {
                            horizontal: true,
                            barHeight: '80%',
                            distributed: true
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: val => val
                    },
                    xaxis: {
                        categories: funnelData.map(i => i.x)
                    },
                    legend: {
                        show: false
                    },
                    noData: {
                        text: 'Nenhum interesse registrado',
                        align: 'center',
                        verticalAlign: 'middle',
                    }
                }
            }
        },

        getPlanOptionLabel(value, creditorType = 3) {
            if (value === null || value === undefined) return 'N/A';

            const options = this.dataset.planOptionText[creditorType] || this.dataset.planOptionText[3] || [];
            const found = options.find(o => Number(o.value) === Number(value));

            return found ? found.text : `Opção ${value}`;
        },

        getEventLabel(eventType) {
            const id = Number(eventType)
            const found = this.charts.eventTypeOptions.find(e => e.value === id)

            return found ? found.text : `Evento ${id}`
        },

        saveFiltersToStorage() {
            var filtersState = {
                filter: Object.assign({}, this.dataList.filter),
                activeTab: this.activeTab,
                metricsFilters: Object.assign({}, this.charts.metricsFilters),
                planOptionFilters: Object.assign({}, this.charts.planOptionFilters),
                page: this.dataList.options.page,
                itemsPerPage: this.dataList.options.itemsPerPage,
            };
            localStorage.setItem('planAdherenceFilters', JSON.stringify(filtersState));
        },

        restoreFiltersFromStorage() {
            var saved = localStorage.getItem('planAdherenceFilters');
            if (!saved) return;

            try {
                var filtersState = JSON.parse(saved);

                if (filtersState.filter) {
                    Object.keys(filtersState.filter).forEach(key => {
                        if (this.dataList.filter.hasOwnProperty(key)) {
                            this.dataList.filter[key] = filtersState.filter[key];
                        }
                    });
                }

                if (filtersState.activeTab !== undefined) {
                    this.activeTab = filtersState.activeTab;
                    var statusMap = { 0: '', 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5 };
                    if (statusMap[filtersState.activeTab] !== undefined) {
                        this.dataList.filter.status = statusMap[filtersState.activeTab];
                    }
                }

                if (filtersState.metricsFilters) {
                    Object.assign(this.charts.metricsFilters, filtersState.metricsFilters);
                }

                if (filtersState.planOptionFilters) {
                    Object.assign(this.charts.planOptionFilters, filtersState.planOptionFilters);
                }

                if (filtersState.page) {
                    this.dataList.options.page = filtersState.page;
                }

                if (filtersState.itemsPerPage) {
                    this.dataList.options.itemsPerPage = filtersState.itemsPerPage;
                }

            } catch (e) {
                console.error('Erro ao restaurar filtros:', e);
            }
        },




    },
};
</script>

<style scoped>
.plan-adherence-table {
    max-width: 100%;
    width: 100%;
}

.plan-adherence-table >>> .v-data-table__wrapper {
    overflow-x: auto;
    max-width: 100%;
    width: 100%;
}

.plan-adherence-table >>> table {
    min-width: 4600px;
    width: max-content;
}

.plan-adherence-table >>> th,
.plan-adherence-table >>> td {
    white-space: nowrap;
}
</style>
